<ng-container *ngIf="tableConfig?.groupConfig">
	<app-group
		[groupConfig]="tableConfig?.groupConfig"
		(isCollapsedEvent)="onGroupContentsVisibilityChange($event)"
	>
		<ng-container
			class="group-main-content"
			*ngTemplateOutlet="tableTpl"
		></ng-container>
	</app-group>
</ng-container>

<ng-container *ngIf="!tableConfig?.groupConfig">
	<ng-container *ngTemplateOutlet="tableTpl"></ng-container>
</ng-container>

<!-- ######################### TEMPLATES ######################### -->

<!-- Table -->
<ng-template #tableTpl>
	<div
		[ngClass]="{
				'table-responsive-sm': tableConfig?.responsive?.isActive && tableConfig?.responsive?.breakpoint === tableResponsiveBreakpointEnum.SM,
				'table-responsive-md': tableConfig?.responsive?.isActive && tableConfig?.responsive?.breakpoint === tableResponsiveBreakpointEnum.MD,
				'table-responsive-lg': tableConfig?.responsive?.isActive && tableConfig?.responsive?.breakpoint === tableResponsiveBreakpointEnum.LG,
				'table-responsive-xl': tableConfig?.responsive?.isActive && tableConfig?.responsive?.breakpoint === tableResponsiveBreakpointEnum.XL
			}"
	>
		<table
			class="table"
			[attr.id]="tableConfig?.identifier"
			[ngClass]="{
				'table-striped': tableConfig?.stripped,
				'table-hover': tableConfig?.hoverable,
				'table-bordered': tableConfig?.bordered,
				'table-borderless': !tableConfig?.bordered,
				'table-rows-spaced': tableConfig?.rowsSpaced,
				'table-sm': tableConfig?.compact
			}"
		>

			<!-- Caption -->
			<ng-container
				*ngIf="tableConfig?.caption?.isRendered"
				[ngTemplateOutlet]="captionTpl"
				[ngTemplateOutletContext]="{ caption: tableConfig?.caption }"
			></ng-container>

			<!-- Header -->
			<ng-container
				*ngIf="tableConfig?.header?.isRendered"
				[ngTemplateOutlet]="headerTpl"
				[ngTemplateOutletContext]="{ header: tableConfig?.header }"
			></ng-container>

			<!-- Body -->
			<ng-container
				*ngIf="tableConfig?.body?.isRendered"
				[ngTemplateOutlet]="bodyTpl"
				[ngTemplateOutletContext]="{ body: tableConfig?.body }"
			></ng-container>

			<!-- Footer -->
			<ng-container
				*ngIf="tableConfig?.footer?.isRendered"
				[ngTemplateOutlet]="footerTpl"
				[ngTemplateOutletContext]="{ footer: tableConfig?.footer }"
			></ng-container>

		</table>
	</div>
</ng-template>

<!-- Caption -->
<ng-template #captionTpl>
	<ng-container [ngSwitch]="tableConfig?.caption?.contentType">

		<!-- Default -->
		<caption
			*ngSwitchCase="contentTypeEnum.DEFAULT"
			class="{{ tableConfig?.caption?.class ? tableConfig?.caption?.class : '' }}"
			[ngClass]="{
				'd-none': tableConfig?.caption?.isHidden,
				'table-caption-position--top':
					isTableCaptionPositionIncluded([tableCaptionPositionEnum.TOP_CENTER, tableCaptionPositionEnum.TOP_LEFT, tableCaptionPositionEnum.TOP_RIGHT]),
				'table-caption-position--bottom':
					isTableCaptionPositionIncluded([tableCaptionPositionEnum.BOTTOM_CENTER, tableCaptionPositionEnum.BOTTOM_LEFT, tableCaptionPositionEnum.BOTTOM_RIGHT]),
				'table-caption-position--center':
					isTableCaptionPositionIncluded([tableCaptionPositionEnum.BOTTOM_CENTER, tableCaptionPositionEnum.TOP_CENTER]),
				'table-caption-position--left':
					isTableCaptionPositionIncluded([tableCaptionPositionEnum.BOTTOM_LEFT, tableCaptionPositionEnum.TOP_LEFT]),
				'table-caption-position--right':
					isTableCaptionPositionIncluded([tableCaptionPositionEnum.BOTTOM_RIGHT, tableCaptionPositionEnum.TOP_RIGHT])
			}"
		>
			{{ getValueByCaptionValueType( tableConfig.caption ) }}
		</caption>

		<!-- Projected -->
		<caption *ngSwitchCase="contentTypeEnum.PROJECTED">
			<ng-content select=".caption-content"></ng-content>
		</caption>
	</ng-container>
</ng-template>

<!-- Header -->
<ng-template #headerTpl>
	<ng-container [ngSwitch]="tableConfig?.header?.contentType">

		<!-- Default -->
		<thead
			*ngSwitchCase="contentTypeEnum.DEFAULT"
			class="{{ tableConfig?.header?.class ? tableConfig?.header?.class : '' }}"

			[ngClass]="{
				'd-none': tableConfig?.header?.isHidden
			}"
		>
			<ng-container
				[ngTemplateOutlet]="rowsTpl"
				[ngTemplateOutletContext]="{
					'cellTypeOverwrite': tableCellTypeEnum.HEADER,
					'rowData': tableConfig?.header?.rowData
				}"
			></ng-container>
		</thead>

		<!-- Projected -->
		<thead *ngSwitchCase="contentTypeEnum.PROJECTED">
			<ng-content select=".header-content"></ng-content>
		</thead>

	</ng-container>
</ng-template>

<!-- Body -->
<ng-template #bodyTpl>
	<ng-container [ngSwitch]="tableConfig.body?.contentType">

		<!-- Default -->
		<tbody
			*ngSwitchCase="contentTypeEnum.DEFAULT"
			class="{{ tableConfig?.body?.class ? tableConfig?.body?.class : '' }}"
			[ngClass]="{
				'd-none': tableConfig?.body?.isHidden
			}"
		>
			<ng-container
				[ngTemplateOutlet]="rowsTpl"
				[ngTemplateOutletContext]="{
					'rowData': tableConfig?.body?.rowData
				}"
			></ng-container>
		</tbody>

		<!-- Projected -->
		<tbody *ngSwitchCase="contentTypeEnum.PROJECTED">
			<ng-content select=".body-content"></ng-content>
		</tbody>
	</ng-container>
</ng-template>

<!-- Footer -->
<ng-template #footerTpl>
	<ng-container [ngSwitch]="tableConfig?.footer?.contentType">

		<!-- Default -->
		<tfoot
			*ngSwitchCase="contentTypeEnum.DEFAULT"
			class="{{ tableConfig?.footer?.class ? tableConfig?.footer?.class : '' }}"
			[ngClass]="{
				'd-none': tableConfig?.footer?.isHidden
			}"
		>
		</tfoot>

		<!-- Projected -->
		<tfoot *ngSwitchCase="contentTypeEnum.PROJECTED">
			<ng-content select=".footer-content"></ng-content>
		</tfoot>

	</ng-container>
</ng-template>

<!-- Rows -->
<ng-template #rowsTpl let-rowData="rowData" let-cellTypeOverwrite="cellTypeOverwrite">
	<tr
		*ngFor="let rowItem of rowData; let first=first; let last=last; let even=even; let odd=odd; let index=index"
		class="{{ rowItem?.class ? rowItem?.class : '' }}"
		[ngClass]="{
			'table-row--even': even,
			'table-row--odd': odd,
			'isHovered': hoverRowItemByIdentifier && rowItem?.identifier === hoverRowItemByIdentifier,
			'disabled': rowItem?.isDisabled
		}"
		(click)="onRowItemEvent(
		{
				identifier: rowItem?.identifier,
				event: { eventId: tableRowItemEventsEnum.CLICK, isClicked: true }
			},
			!rowItem.disableEventEmit
		)"
		(mouseenter)="onRowItemEvent(
		{
				identifier: rowItem?.identifier,
				event: { eventId: tableRowItemEventsEnum.HOVER, isHovered: true }
			},
			!rowItem.disableEventEmit
		)"
		(mouseleave)="onRowItemEvent(
		{
				identifier: rowItem?.identifier,
				event: { eventId: tableRowItemEventsEnum.HOVER, isHovered: false }
			},
			!rowItem.disableEventEmit
		)"
	>
		<ng-container
			[ngTemplateOutlet]="cellsTpl"
			[ngTemplateOutletContext]="{
				cellTypeOverwrite: cellTypeOverwrite,
				cellData: rowItem?.cellData,
				isFirstRow: first,
				isLastRow: last,
				rowIdx: index
			}"
		></ng-container>
	</tr>
</ng-template>

<!-- Cells -->
<ng-template
	#cellsTpl
	let-cellTypeOverwrite="cellTypeOverwrite"
	let-cellData="cellData"
	let-isFirstRow="isFirstRow"
	let-isLastRow="isLastRow"
	let-rowIdx="rowIdx"
>

	<!-- Header -->
	<ng-container *ngIf="isHeaderCellType(cellTypeOverwrite, cellData?.cellType)">
		<th
			*ngFor="let cellItem of cellData; let isFirstRowCell=first; let isLastRowCell=last; let rowCellIdx=index"
			class="pb-0 fs-sx fw-regular {{ cellItem?.class ? cellItem?.class : '' }}"
			[ngClass]="{
				'disabled': cellItem?.isDisabled
			}"
			[attr.colspan]="cellItem?.attributes?.colspan"
			[attr.rowspan]="cellItem?.attributes?.rowspan"
		>

			<ng-template
				#defaultTableHeaderItemTpl
				let-cellItem="cellItem"
			>
				<span
					appSetAttributeDirective
					[attribute]="getInnerCellContentType(cellItem)"
					[sanitizeDom]="cellItem?.applyDomSanitizerToHtmlContent"
					[value]="getValueByCellValueType(cellItem)"
				></span>
			</ng-template>

			<ng-template
				[ngTemplateOutlet]="cellItem?.enforceCustomTemplate ? tableHeaderItemTpl : defaultTableHeaderItemTpl"
				[ngTemplateOutletContext]="{
					cellItem: cellItem,
					isFirstRow: isFirstRow,
					isLastRow: isLastRow,
					rowIdx: rowIdx,
					isFirstRowCell: isFirstRowCell,
					isLastRowCell: isLastRowCell,
					rowCellIdx: rowCellIdx
				}"
			></ng-template>
		</th>
	</ng-container>

	<!-- Standard -->
	<ng-container *ngIf="!isHeaderCellType(cellTypeOverwrite, cellData?.cellType )">
		<td
			*ngFor="let cellItem of cellData; let isFirstRowCell=first; let isLastRowCell=last; let rowCellIdx=index"
			class="fs-md fw-regular {{ cellItem?.class ? cellItem?.class : '' }}"
			[ngClass]="{
				'disabled': cellItem?.isDisabled
			}"
			[attr.colspan]="cellItem?.attributes?.colspan"
			[attr.rowspan]="cellItem?.attributes?.rowspan"
		>

			<ng-template
				#defaultTableBodyItemTpl
				let-cellItem="cellItem"
			>
				<span
					appSetAttributeDirective
					[attribute]="getInnerCellContentType(cellItem)"
					[sanitizeDom]="cellItem?.applyDomSanitizerToHtmlContent"
					[value]="getValueByCellValueType(cellItem)"
				></span>
			</ng-template>

			<ng-template
				[ngTemplateOutlet]="cellItem?.enforceCustomTemplate ? tableBodyItemTpl : defaultTableBodyItemTpl"
				[ngTemplateOutletContext]="{
					cellItem: cellItem,
					isFirstRow: isFirstRow,
					isLastRow: isLastRow,
					rowIdx: rowIdx,
					isFirstRowCell: isFirstRowCell,
					isLastRowCell: isLastRowCell,
					rowCellIdx: rowCellIdx
				}"
			></ng-template>
		</td>
	</ng-container>
</ng-template>
